import { CircularProgress, Button as MaterialButton } from '@mui/material';
import React, { ComponentProps } from 'react';

type Props = {
  children: React.ReactNode;
  loading?: boolean;
} & ComponentProps<typeof MaterialButton>;

const Button = ({ children, loading = false, ...props }: Props) => (
  <MaterialButton {...props} disabled={props.disabled || loading}>
    {loading ? (
      <div className="flex items-center justify-center align-bottom">
        <CircularProgress size={26} color="inherit" />
      </div>
    ) : (
      children
    )}
  </MaterialButton>
);

export { Button };
